import { render, staticRenderFns } from "./CrmSale.vue?vue&type=template&id=75675aea"
import script from "./CrmSale.vue?vue&type=script&lang=js"
export * from "./CrmSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports